<template>
    <div>
        <div class="row mb-4">
            <div class="col">
                <div class="float-right">
                    <button @click="addLocation" class="btn btn-primary"
                        v-if="!spark.state.user.is_location_user">
                        <i class="fa fa-map-marker-alt"></i>
                        New {{ uiType == 'location' ? 'Location' : 'Provider' }}
                    </button>
                </div>

                <div class="form-inline">
                    <select class="form-control" v-model="selected_location">
                        <option :value="null">All {{ uiType == 'location' ? 'Locations' : 'Providers' }}</option>
                        <option v-for="location of locations" :key="location.id"
                            :value="location.id">
                            {{ location.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-4" v-for="location in filtered_locations" :key="location.id">
                <location-widget
                    :location="location"
                    @openDetailsModal="openDetails"
                    @openReviewWidgetModal="openReviewWidget"
                    @click:manage="edit"
                    @click:delete="deleted"
                />
            </div>

            <div class="col-md-4 mb-4" v-if="!spark.state.user.is_location_user">
                <card class="h-100 m-0 placeholder" @click.native="addLocation">
                    <card-body class="h-100">
                        <div class="h-100">
                            <div class="row align-items-center text-center h-100">
                                <div class="col">
                                    <div><i class="fa fa-plus" style="font-size: 3rem;"></i></div>
                                    Add New {{ uiType == 'location' ? 'Location' : 'Provider' }}
                                </div>
                            </div>
                        </div>
                    </card-body>
                </card>
            </div>
        </div>

        <location-form
            :ui-type="uiType"
            :location-selected="location"
            @hide-modal-form="close"
            @changed="loadLocations"
        />

        <location-detail
            ref="details"
            :location-details="location_detail"
        />

        <location-review-widget
            ref="widget"
            :location="location_widget"
        />
    </div>
</template>

<script>
    import LocationWidget from './LocationWidget';
    import LocationForm from './LocationForm';
    import LocationDetail from './LocationDetail';

    export default {
        components: {LocationWidget, LocationForm, LocationDetail},

        props: {
            uiType: { type: String, in: ['location', 'provider'] }
        },

        data() {
            return {
                locations: [],
                location: null,
                location_detail: null,
                selected_location: null,
                location_widget: null
            }
        },

        created() {
            this.loadLocations();
        },

        computed: {
            filtered_locations() {
                return !this.selected_location ? this.locations : this.locations.filter(location => location.id === this.selected_location)
            }
        },

        methods: {
            async addLocation() {
                if(await this.canCreateNewLocation()){
                    this.open();
                }else{
                    this.$alert({type: 'error', title: 'Unable to create new location', message: 'Please contact customer support regarding new location creation.' });
                }

            },

            edit(location) {
                this.open(location);
            },

            async canCreateNewLocation() {
                let canCreateNewLocation = false;
                await this.$http.get('/api/locations/can-create-new-location', { params: {}})
                    .then(({data}) => {
                       canCreateNewLocation = data.result;
                    });

                return canCreateNewLocation;
            },

            open(location = {}) {
                this.location = location;
            },

            close(value) {
                if (!value) {
                    this.location = null;
                }
            },

            openDetails(location) {
                this.$refs.details.open();
                this.location_detail = location;
            },

            openReviewWidget(location) {
                this.$refs.widget.open();
                this.location_widget = location;
            },

            loadLocations(locationId = null) {
                this.$http.get(this.$laroute.route('api.locations.index'), { params: { type: this.uiType }})
                    .then(({data}) => {
                        this.locations = data.data;

                        if (locationId) {
                            this.location = this.locations.find(location => location.id === locationId);
                        }
                    });
            },

            deleted(location) {
                this.$confirm().then(() => {
                    this.$http.delete(this.$laroute.route('api.locations.destroy', { location: location.id }))
                        .then(res => {
                            const message = res.data.message
                            console.log('response from delete', message, res)
                            this.$alert({ message, type: 'success', title: 'Success!' });
                            this.loadLocations();
                        })
                        .catch(err => console.log('err from delete', err))
                });
            }
        }
    }
</script>

<style lang="sass" scoped>
    $bg-color: #dde4e7
    $time-effect: .15s
    $grey-color: #8d8d8d
    .placeholder
        border: 3px dashed $grey-color
        color: darken($grey-color, 10%)
        min-height: 300px
        cursor: pointer
        background-color: $bg-color
        opacity: 0.5
        -webkit-transition: opacity $time-effect
        -moz-transition: opacity $time-effect
        -ms-transition: opacity $time-effect
        -o-transition: opacity $time-effect
        transition: opacity $time-effect
        &:hover
            opacity: 1
            -webkit-transition: opacity $time-effect
            -moz-transition: opacity $time-effect
            -ms-transition: opacity $time-effect
            -o-transition: opacity $time-effect
            transition: opacity $time-effect

</style>
